"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtbAffiliationMap = exports.GtbMemberRoles = void 0;
exports.GtbMemberRoles = ["admin"];
exports.GtbAffiliationMap = {
    "management-company": "Activation Partner",
    marketing: "GTB Associate",
    label: "GTB Director",
    crew: "GTB Manager",
    other: "Other",
    artist: "Unknown",
};
//# sourceMappingURL=gtb.js.map